import React, { useEffect, useMemo, useState } from 'react';
import { Table, Typography, message } from 'antd';
import { permissionService, Permission } from '../services/permissions';

const { Title } = Typography;

type PermissionRow = Permission & {
  module: string;
  action: string;
};

export const Permissions: React.FC = () => {
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    setLoading(true);
    try {
      const data = await permissionService.getAll();
      setPermissions(data);
    } catch {
      message.error('Failed to load permissions');
    } finally {
      setLoading(false);
    }
  };

  const dataSource = useMemo(
    () =>
      permissions.map((permission) => {
        const [module, action] = permission.name.split('.', 2);
        return {
          ...permission,
          module: module ?? '',
          action: action ?? '',
        };
      }),
    [permissions]
  );

  const columns = [
    {
      title: 'Permission',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Module',
      dataIndex: 'module',
      key: 'module',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
    },
  ];

  return (
    <div>
      <Title level={3} style={{ marginBottom: 16 }}>
        Permissions
      </Title>
      <Table
        columns={columns}
        dataSource={dataSource as PermissionRow[]}
        rowKey="id"
        loading={loading}
        pagination={false}
      />
    </div>
  );
};
